export default __webpack_public_path__ + "static/media/tech-camps-icon.6efef630.png";